const state = {
    executionCategoryMid:'',
    iCategoryList:[],
    eCategoryList:[],
    selectICategory:[],
    sekectECategory:[]
    
  };
  const actions = {
    setSelectICategory(state,payload){ 
       /*  let url ="/api/copaper/paper/getCategoryPaperList"; //url 정보
        let method = "post"; // get or post
        let req  =payload;
        axios
        .post(url, req)
        .then(res => {
            console.log(" 불러옴 ~");
        })
        .catch(err => console.log(err)); */
        
    },
    setSelectECategory(state,payload){
          
    }
  };
  const mutations = {
    setExecutionCategoryMid(state, payload) {
        state.executionCategoryMid = payload;
    },
    setIcategoryList(state, payload){
        state.iCategoryList=payload;
    },
    setEcategoryList(state,payload){
        state.eCategoryList=payload;
    }
  };
  const getters = {
      getExecutionCategoryMid(state){
          return state.executionCategoryMid;
      },
      getEcategoryList(state){
          return state.eCategoryList;
      },
      getIcategoryList(state){
          return state.iCategoryList;
      },
      getSelectICategory(state){
          return state.selectICategory;
      },
      getSelectECategory(state){

      }
  };

  import axios from "axios";
  export default { state, actions, mutations, getters, namespaced: true };
  


// WEBPACK FOOTER //
// ./src/js/store/module/assignment/assignment.js